import React from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import { FiPenTool, FiLayers, FiClock } from 'react-icons/fi';
import Wrapper from '../assets/wrappers/Nft';
import Info from './Info';
import { shortenAddress } from '@usedapp/core';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import {
  getEtherscanLink,
  getIPFSLink,
  getOpenSeaLink,
  truncateMessage,
} from '../utils/textUtils';
import { useDispatch } from 'react-redux';
import { setSelected } from '../features/nft/nftSlice';
import { getImageUrl } from '../utils/image';

const Nft = ({ chainId, _nftId, contract, openAt, tokenURI, data }) => {
  const dispatch = useDispatch();
  const date = moment(data.attributes_map?.finished || openAt).format(
    'MMM Do, YYYY'
  );
  return (
    <Wrapper>
      <header>
        <div className='info'>
          <h5>{data.name}</h5>
          <p>{truncateMessage(data.description, 100)}</p>
        </div>
      </header>
      <div className='content'>
        <NavLink
          to='/replay'
          onClick={(e) => {
            dispatch(setSelected({ data }));
          }}
        >
          <img className='nft-icon' src={getImageUrl(data)} alt='Not found' />
        </NavLink>

        <div className='content-center'>
          <Info icon={<FaCalendarAlt />} text={`Finished: ${date}`} />

          <Info
            icon={<FiLayers />}
            text={`Length: ${
              data.attributes_map?.text_length || data.description.length
            }`}
          />
          <Info
            icon={<FiPenTool />}
            text={`Author: ${shortenAddress(data.author)}`}
            link={getEtherscanLink(chainId, data.author)}
          />
          <Info
            icon={<FiClock />}
            text={`Effort: ${(
              data.attributes_map?.duration_millisec / 60000 || 0
            ).toFixed(2)} Minutes`}
          />
        </div>
        <footer>
          <div className='actions'>
            <a href={data.external_url} className='btn edit-btn'>
              View
            </a>
            <a href={getIPFSLink(tokenURI)} className='btn edit-btn'>
              Json
            </a>

            <a
              href={getOpenSeaLink({ chainId, _nftId, contract })}
              className='btn edit-btn'
            >
              Trade
            </a>
          </div>
        </footer>
      </div>
    </Wrapper>
  );
};

export default Nft;
